import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import Button from '@prisjakt/ui-button';
import { Topic } from './components/forum-topic';
import { ForumTopicConnection } from '../../../../types';
import * as S from './styles';
import { IconChat } from '@prisjakt/ui/icon';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  topics: Omit<ForumTopicConnection, 'pageInfo'>;
};

const ForumTopicListing = ({ topics }: Props) => {
  const { t, market } = useContext(AppContext);

  if (!topics.nodes?.length) {
    return null;
  }

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle>{t('footer', 'forum.title')}</PanelTitle>
      </PanelHeader>

      <S.ForumTopic>
        <S.Topics>
          {topics.nodes.map(topic =>
            topic ? <Topic key={topic.id} topic={topic} /> : null
          )}
        </S.Topics>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={market.forum} target="_blank" rel="noopener">
          <S.Forum>
            <IconChat size={60} color="base300" />
            <Button
              color="primary"
              onClick={() => {
                if (market.forum)
                  trackInternalNavigationClick({
                    scope: InternalNavigationScope.FORUM_GO_TO,
                    nextPage: market.forum,
                  });
              }}
            >
              {t('landing', 'forum.go-to')}
            </Button>
          </S.Forum>
        </a>
      </S.ForumTopic>
    </Panel>
  );
};

export default memo(ForumTopicListing);
